import React from 'react';
import MarketoForm from 'components/Form/MarketoForm';
import { getRTInlineMarketingFormProps } from 'utils/marketo';

const RichTextInlineMarketingForm = ({ dataPosition, formType, fields, ...otherProps }) => {
  return (
    <MarketoForm
      className="rich-text-content--marketo-form-embed"
      data-position={dataPosition || 'Embedded Marketo Form'}
      formType={formType}
      {...getRTInlineMarketingFormProps(fields)}
      {...otherProps}
    />
  );
};

export default RichTextInlineMarketingForm;
